module.exports = __webpack_public_path__ + "static/media/RightDisbaled.f1fca32e.svg";